import { render } from "./cell_percent.vue?vue&type=template&id=781e2e18"
import script from "./cell_percent.vue?vue&type=script&lang=ts"
export * from "./cell_percent.vue?vue&type=script&lang=ts"
script.render = render

export default script